<template>
  <DMModal @modal-close="reset" name="contact" class="text-center">
    <a class="hover:text-dm mb-3 block" href="mailto:info@designmorphine.com" target="_blank"
      >info@designmorphine.com</a
    >
    <label>
      <input
        v-model="contact.email"
        class="text-input placeholder-gray-500 placeholder-opacity-50 mb-3"
        type="text"
        placeholder="Email"
      />
      <p v-if="request.error === true && request.data.errors.email" class="text-red-500 text-center mb-3">
        {{ request.data.errors.email[0] }}
      </p>
    </label>

    <label>
      <input
        v-model="contact.first_name"
        class="text-input placeholder-gray-500 placeholder-opacity-50 mb-3"
        type="text"
        placeholder="First Name"
      />
      <p v-if="request.error === true && request.data.errors.first_name" class="text-red-500 text-center mb-3">
        {{ request.data.errors.first_name[0] }}
      </p>
    </label>

    <label>
      <input
        v-model="contact.last_name"
        class="text-input placeholder-gray-500 placeholder-opacity-50 mb-3"
        type="text"
        placeholder="Last Name"
      />
      <p v-if="request.error === true && request.data.errors.last_name" class="text-red-500 text-center mb-3">
        {{ request.data.errors.last_name[0] }}
      </p>
    </label>

    <label>
      <input
        class="text-input placeholder-gray-500 placeholder-opacity-50 mb-3"
        type="text"
        v-model="contact.subject"
        placeholder="Subject"
      />
      <p v-if="request.error === true && request.data.errors.subject" class="text-red-500 text-center mb-3">
        {{ request.data.errors.subject[0] }}
      </p>
    </label>

    <label>
      <textarea
        v-model="contact.message"
        class="text-input placeholder-gray-500 placeholder-opacity-50 mb-3"
        placeholder="Message"
        :rows="5"
      />
      <p v-if="request.error === true && request.data.errors.message" class="text-red-500 text-center mb-3">
        {{ request.data.errors.message[0] }}
      </p>
    </label>
    <p v-if="request.sent === true" class="text-green-500 text-center font-medium mb-3">
      {{ request.data.message }}
    </p>
    <button
        v-if="!sending"
      :disabled="!canSend"
      @click="handle"
      :class="{
        'mx-auto bg-white-50 w-1/2 py-2 px-3 rounded-full mb-3 text-center': true,
        'opacity-50': !canSend,
        'hover:bg-dm': canSend,
      }"
    >
      Send
    </button>
    <loader class="mx-auto" v-else />
  </DMModal>
</template>

<script>
import DMModal from '@components/DMModal';
import Loader from '@components/Loader';

export default {
  name: 'ContactModal',
  components: {
    Loader,
    DMModal,
  },
  data() {
    return {
      contact: {
        email: null,
        first_name: null,
        last_name: null,
        subject: null,
        message: null,
      },
      request: {
        error: false,
        sent: false,
        data: {},
      },
      sending: false,
    };
  },
  computed: {
    canSend() {
      return (
        !this.sending &&
        this.contact.email !== null &&
        this.contact.first_name !== null &&
        this.contact.last_name !== null &&
        this.contact.subject !== null &&
        this.contact.message !== null
      );
    },
  },
  methods: {
    handle() {
      this.sending = true;
      this.request.error = false;
      this.request.sent = false;
      this.request.data = {};
      axios
        .post('/api/contact', this.contact)
        .then(({ status, data }) => {
          if (status === 200) {
            if (data.contact) {
              this.request.sent = true;
              this.contact = {
                email: null,
                first_name: null,
                last_name: null,
                subject: null,
                message: null,
              };
              this.request.data.message = 'Contact succesfully sent! We will get back to you as soon as we can.';
            } else {
              this.request.error = true;
              this.request.data.unknown = true;
              this.request.data.errors = {};
              this.request.data.message =
                'There was an unexpected issue submitting the contact details, please try again.';
            }
          }
        })
        .catch(({ response }) => {
          if (response.status === 422) {
            // Validation
            this.request.error = true;
            this.request.data = response.data;
          }
        })
        .finally(() => {
          this.sending = false;
          this.$set(this.$data, 'request', this.request);
        });
    },
    reset() {
      this.contact = {
        email: null,
        subject: null,
        message: null,
      };
      this.request = {
        error: false,
        sent: false,
        data: {},
      };
    },
  },
};
</script>

<style scoped></style>
